module.exports = "<a class=\"btn btn-success btn-modal-ok\"><%= translatedStrings['430ff666-98b7-4018-9fff-68b9f81f8c4a'] %></a>\n";